module.exports = __webpack_public_path__ + "img/rp_09.319bec50.jpg";